import { BaSeBreakpointContext, BaSeButton } from '@base/react';
import React from 'react';
import { Container } from './style';

// import { Container } from './styles';

function Button({
  value,
  calback,
  valueSmall,
  color,
  withBorder = false,
  loading = false,
  borderColor,
  disabled,
  textColor = '#fff',
  type = 'primary',
}) {
  const breakpointController = React.useContext(BaSeBreakpointContext);

  const setWidth = React.useCallback(() => {
    if (
      breakpointController.inTablet ||
      breakpointController.inDesktop ||
      breakpointController.inDesktopLarge
    ) {
      return true;
    }
    return false;
  }, [breakpointController]);

  const setTextToButton = React.useCallback(
    (value, valueSmall) => {
      if (setWidth()) {
        return value;
      }
      return valueSmall;
    },
    [setWidth],
  );

  return (
    <Container withBorder={withBorder} borderColor={borderColor}>
      <BaSeButton
        isDisabled={disabled}
        onClick={() => calback()}
        value={setTextToButton(value, valueSmall)}
        type={type}
        color={color}
        isLoading={loading}
        overrideColors={{
          foreground: textColor,
        }}
      />
    </Container>
  );
}

export default Button;
